import { render, staticRenderFns } from "./TableUnitPriceV2.vue?vue&type=template&id=9788e064&scoped=true"
import script from "./TableUnitPriceV2.vue?vue&type=script&lang=js"
export * from "./TableUnitPriceV2.vue?vue&type=script&lang=js"
import style0 from "./TableUnitPriceV2.vue?vue&type=style&index=0&id=9788e064&prod&scoped=true&lang=css"
import style1 from "./TableUnitPriceV2.vue?vue&type=style&index=1&id=9788e064&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9788e064",
  null
  
)

export default component.exports